
import { useNavigate } from "react-router-dom";
const CourseCards = ({ filteredCourses, loading }) => {
  // console.log("The filtered Course are:",filteredCourses)
  const navigate = useNavigate();
  return (
   <div className="w-full flex justify-center items-center px-0 ">
  <div className="grid gap-6 w-full  grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
    {loading
      ? Array(6)
          .fill(0)
          .map((_, idx) => (
            <div
              key={idx}
              className="animate-pulse bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden flex flex-col min-h-[480px]"
            >
              <div className="h-[200px] bg-gray-200 rounded-xl m-5"></div>
              <div className="px-5 pb-5 flex flex-col flex-1">
                <div className="h-6 w-20 bg-gray-200 rounded-lg mb-3"></div>
                <div className="h-6 w-3/4 bg-gray-200 rounded-lg mb-2"></div>
                <div className="h-4 w-full bg-gray-200 rounded mb-2"></div>
                <div className="h-4 w-5/6 bg-gray-200 rounded mb-2"></div>
                <div className="h-4 w-4/6 bg-gray-200 rounded mb-4"></div>
                <div className="flex gap-2 mb-4">
                  <div className="h-6 w-16 bg-gray-200 rounded-full"></div>
                  <div className="h-6 w-16 bg-gray-200 rounded-full"></div>
                </div>
                <div className="flex items-center gap-2 mb-4">
                  <div className="w-10 h-10 bg-gray-200 rounded-full"></div>
                  <div className="flex-1">
                    <div className="h-4 w-24 bg-gray-200 rounded mb-1"></div>
                    <div className="h-3 w-32 bg-gray-200 rounded"></div>
                  </div>
                </div>
                <div className="h-10 w-full bg-gray-200 rounded-xl mt-auto"></div>
              </div>
            </div>
          ))
      : filteredCourses.map((course) => {
          const user = course.teacher.user;

          let typeLabel = "";
          if (course.learning_type === 2) typeLabel = "Video";
          if (course.learning_type === 3) typeLabel = "Audio";
          if (course.learning_type === 4) typeLabel = "Podcast";

          return (
            <div
              key={`${course.type_id}-${course.id}`}
              className="bg-white rounded-2xl border border-gray-200 shadow-sm flex flex-col min-h-[480px] transition-all duration-300 hover:shadow-lg hover:border-gray-300 overflow-hidden"
            >
              {/* Thumbnail */}
              <div className="relative h-[200px] m-5 mb-0 rounded-xl overflow-hidden bg-gray-50">
                {course.learning_type === 1 && (
                  <img
                    src={course.image}
                    alt={course.name}
                    className="w-full h-full object-cover"
                  />
                )}

               {course.learning_type === 2 && (
  <div className="relative w-full h-full">
    <video
      src={course.file}
      className="w-full h-full object-cover"
      controls={
        course.payment_status === "paid" ||
        course.course_type === "free" ||
        course.is_purchased
      }
    />

    {course.payment_status !== "paid" &&
      course.course_type !== "free" &&
      !course.is_purchased && (
        <div
          className="absolute inset-0 flex flex-col justify-center items-center cursor-not-allowed bg-black/60 backdrop-blur-sm"
          onClick={() =>
            alert("Payment required to play this audio")
          }
        >
          <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mb-2">
            <svg
              className="w-6 h-6 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
              />
            </svg>
          </div>
          <span className="text-white text-sm font-medium">Locked</span>
        </div>
      )}
  </div>
)}
              {course.learning_type === 3 && (
  <div className="relative w-full h-full flex items-center justify-center bg-gradient-to-b from-gray-900 to-black">
    <div className="absolute inset-0 flex items-center justify-center">
      <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center">
        <svg className="w-8 h-8 text-white/60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
        </svg>
      </div>
    </div>

    <audio
      src={course.file}
      controls={
        course.payment_status === "paid" ||
        course.course_type === "free" ||
        course.is_purchased
      }
      className={`w-full absolute bottom-3 left-0 px-3 ${
        course.payment_status !== "paid" &&
        course.course_type !== "free" &&
        !course.is_purchased
          ? "opacity-50"
          : ""
      }`}
    />

    {course.payment_status !== "paid" &&
      course.course_type !== "free" &&
      !course.is_purchased && (
        <div
          className="absolute inset-0 flex flex-col justify-center items-center cursor-not-allowed bg-black/60 backdrop-blur-sm"
          onClick={() =>
            alert("Payment required to play this audio")
          }
        >
          <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mb-2">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
          <span className="text-white text-sm font-medium">Locked</span>
        </div>
      )}
  </div>
)}
              {course.learning_type === 4 && (
  <div className="relative w-full h-full">
    <video
      src={course.file}
      className="w-full h-full object-cover"
      controls={
        course.payment_status === "paid" ||
        course.course_type === "free" ||
        course.is_purchased
      }
    />

    {course.payment_status !== "paid" &&
      course.course_type !== "free" &&
      !course.is_purchased && (
        <div
          className="absolute inset-0 flex flex-col justify-center items-center cursor-not-allowed bg-black/60 backdrop-blur-sm"
          onClick={() =>
            alert("Payment required to play this audio")
          }
        >
          <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mb-2">
            <svg
              className="w-6 h-6 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
              />
            </svg>
          </div>
          <span className="text-white text-sm font-medium">Locked</span>
        </div>
      )}
  </div>
)}
              </div>

              {/* Content */}
              <div className="p-5 flex flex-col flex-1">
                {typeLabel && (
                  <div className="flex items-center gap-2 mb-3">
                    <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                    <span className="text-xs font-semibold text-[#0f6abf] uppercase tracking-wide">
                      {typeLabel}
                    </span>
                  </div>
                )}

                <h3 className="text-lg font-semibold text-gray-900 mb-2 line-clamp-2">
                  {course.name}
                </h3>

                <p className="text-sm text-gray-600 mb-4 line-clamp-3 flex-1 leading-relaxed">
                  {course.description}
                </p>

                <div className="flex flex-wrap gap-2 mb-4">
                  <span className="px-3 py-1.5 bg-[#e8f0f7] text-[#0f6abf] text-xs font-medium rounded-lg">
                    {course.course_type === "free" ? "Free" : `$${course.price}`}
                  </span>
                </div>

                {user && (
                  <div className="flex items-center gap-3 mb-4 p-3 bg-gray-50 rounded-xl">
                    <img
                      src={user.profile_image}
                      alt={user.name}
                      className="w-10 h-10 rounded-lg object-cover cursor-pointer hover:ring-2 hover:ring-[#0f6abf] transition-all"
                      onClick={() =>
                        navigate(`/teacher-profile/${course?.teacher?.id}`)
                      }
                    />
                    <div className="flex-1 min-w-0">
                      <h6 className="text-sm font-medium text-gray-900 truncate">
                        {user.name}
                      </h6>
                      <p className="text-xs text-gray-500 truncate">{user.email}</p>
                    </div>
                  </div>
                )}
                  {
                    course?.is_purchased ? 
                     <button
                 onClick={() => {
  if (course.learning_type === 1) navigate("/student/courses");
  else if (course.learning_type === 2) navigate("/course/videos");
  else if (course.learning_type === 3) navigate("/course/audios");
  else navigate("/course/podcasts");
}}

                  className="mt-auto py-3 px-4 w-full bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-all disabled:opacity-50"
                >
                  Go to Course
                </button> 
                :
                 <button
                  onClick={() =>
                    navigate(
                      `/course/${course?.teacher?.id}/${course.learning_type}/${course.id}`
                    )
                  }
                  className="mt-auto py-3 px-4 w-full bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-all disabled:opacity-50"
                >
                  Course Details
                </button>
                  }
               
              </div>
            </div>
          );
        })}
    </div>
  </div>
  );
};

export default CourseCards;
